import { createFileRoute } from '@tanstack/react-router';
import { Card } from '@/components/ui/Card';

export const Route = createFileRoute('/status-page/')({
  component: StatusPagePage,
});

function StatusPagePage(): JSX.Element {
  return (
    <div className="flex flex-col gap-4">
      <header>
        <h1 className="text-2xl font-semibold">Status-Page</h1>
        <p className="text-muted">Public Status-Page Build &amp; Push.</p>
      </header>
      <Card>
        <p className="text-sm text-muted">
          Bewusst zurueckgestellt (ADR-007-Amendment) &mdash; siehe Roadmap. Der
          Mail-Versand an Kunden ist separat in Planung; Spezifikation liegt vor.
        </p>
      </Card>
    </div>
  );
}
